import theme from 'theme';
import styled from 'styled-components';
import { Tabs, Tab } from 'components/ui';

export const MainTabs = styled(Tabs)`
`;

export const MainTab = styled(Tab)`
  background-color: ${theme.palette.primary.white};
`;

export const MainTabsContent = styled.div`
  background-color: ${theme.palette.primary.white};
  padding: ${theme.padding.small};
  padding-top: ${theme.padding.content};
  min-height: 300px;
`;
